import { memo, ReactNode, RefObject } from "react";

import { FILTERS_ORDER_SETTINGS_KEY } from "views/Account/Stacks/constants";
import InteractiveColumn from "ds/components/Table/Head/InteractiveColumn";
import { TableColumnMeta } from "ds/components/Table/types";

import useIacTableStore from "../useIacTableStore";

type IacManagementTableHeadColumnProps = {
  column: TableColumnMeta;
  stickyLeft?: boolean;
  stickyRight?: boolean;
  children?: ReactNode;
  tableRef: RefObject<HTMLDivElement | null>;
};

const IacManagementTableHeadColumn = memo(
  ({ column, stickyLeft, stickyRight, children, tableRef }: IacManagementTableHeadColumnProps) => {
    return (
      <InteractiveColumn
        column={column}
        store={useIacTableStore}
        stickyLeft={stickyLeft}
        stickyRight={stickyRight}
        filtersStorageKey={FILTERS_ORDER_SETTINGS_KEY}
        tableRef={tableRef}
      >
        {children}
      </InteractiveColumn>
    );
  }
);

IacManagementTableHeadColumn.displayName = "IacManagementTableHeadColumn";

export default IacManagementTableHeadColumn;
